import React from "react";

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 40 
}) => {
  return (
    <div style={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center", 
      height: "100vh",
      flexDirection: "column",
      gap: "16px"
    }}>
      <div style={{ 
        width: size, 
        height: size, 
        border: "4px solid rgb(var(--color-secondTextColor) / 0.2)", 
        borderTop: "4px solid rgb(var(--color-activeColor))", 
        borderRadius: "50%", 
        animation: "spin 1s linear infinite" 
      }} />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;